
import Hero from './components/Hero';
import WhoWeAre from './components/WhoWeAre';
import ByTheNumbers from './components/ByTheNumbers';
import Mission from './components/Mission';
import WhatSetsUsApart from './components/WhatSetsUsApart';
import WhereWeAreGoing from './components/WhereWeAreGoing';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WhoWeAre />
      <ByTheNumbers />
      <Mission />
      <WhatSetsUsApart />
      <WhereWeAreGoing />
      <Contact />
    </div>
  );
}
